import { InputForm, SubmitButton, Error } from "components";
import { ResetPasswordInput, ResetPasswordInputError } from "modules/auth/users/store/actionType";
interface FormProps {
  handleSave: (event: React.FormEvent<HTMLButtonElement>) => void;
  formData: ResetPasswordInput;
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  error: ResetPasswordInputError;
  loading: boolean;
  header:string;
}
const PasswordReset: React.FC<FormProps> = ({
  formData,
  handleChange,
  error,
  loading,
  handleSave,
  header
}) => {
  return (
    <section className="w-full flex flex-col items-center justify-center p-4">
      <form className="w-full max-w-screen-md">
        <h2 className="text-2xl font-bold text-center mb-4">{header}</h2>
        <div className="grid grid-cols-1 gap-3">
          <div>
            <InputForm
              label={`Enter Password`}
              type="text"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
            />
            {error.password && <Error>{error.password}</Error>}
          </div>
          <div>
            <InputForm
              label="Confirm Password"
              type="text"
              id="confirm_password"
              name="confirm_password"
              value={formData.confirm_password}
              onChange={handleChange}
            />
            {error.confirm_password && <Error>{error.confirm_password}</Error>}
          </div>
        </div>
        <div className="flex items-center justify-between mt-6">
          <SubmitButton loading={loading} onClick={handleSave} />
        </div>
      </form>
    </section>
  );
};
export default PasswordReset;
